import DashboardLayout from "../dashboard/layout/DashboardLayout";
import LeadsList from "../leads/LeadsList";
import { useNavigate } from "react-router-dom";
import { FileUp, Plus, UploadCloud } from "lucide-react";
import { useRef } from "react";

export default function LeadsPage() {
  const navigate = useNavigate();
  const leadsListRef = useRef<{ openCreateDialog: () => void }>(null);
  
  // Define action buttons
  const actionButtons = [
    {
      label: "Add Lead",
      onClick: () => leadsListRef.current?.openCreateDialog(),
      icon: <Plus size={16} />,
      variant: "default" as const,
      className: "bg-primary hover:bg-primary/80 text-primary-foreground"
    },
    {
      label: "Upload CSV",
      onClick: () => navigate("/lead-uploads"),
      icon: <UploadCloud size={16} />,
      variant: "outline" as const
    }
  ];

  return (
    <DashboardLayout
      activeItem="Leads"
      title="Leads"
      description="Manage your leads"
      actionButtons={actionButtons}
    >
      <LeadsList ref={leadsListRef} />
    </DashboardLayout>
  );
}